import React, { useContext } from 'react';
import clsx from 'clsx';
import moment from 'moment/moment';
import { Loader } from 'components';
import { PaymentSavedCard } from './PaymentSavedCard';
import { PaymentItem } from './PaymentItem';
import { Constants } from 'libs';
import { AppDataContext } from 'contexts/appData';
import { usePaymentContext } from '../PaymentProvider';
import { UserContext } from 'contexts/user';
import { PAYMENT_FLOW_VIEWS, PaymentGroupEnum, PaymentMethodsEnum, PaymentMethodsIconsEnum } from '../helpers';
import PayWithCard from './PayWithCard';
import Wallets from './Wallets';
import { PaymentCardGroup } from './PaymentCardGroup';

const PaymentMethods = () => {
  const { langs } = useContext(AppDataContext);
  const {
    isLoading,
    isPaymentProcessing,
    paymentOptions,
    totalAmount,
    isInsufficientBalanceAmount,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    selectedCard,
    setSelectedCard,
    saveCard,
    setSaveCard,
    paymentFlowView,
    cardSelection,
    handlePayment,
    fetchWalletToken,
    trackPaymentMethodSelection,
  } = usePaymentContext();
  const { userBalance } = useContext(UserContext);

  const handleChangeWalletMethod = (paymentOption) => {
    setSelectedPaymentMethod(paymentOption)
    trackPaymentMethodSelection(paymentOption)
    fetchWalletToken({paymentOption})
  }


  if (isLoading) {
    return (
      <div className="h-380px">
        <Loader />
      </div>
    );
  }

  if (paymentFlowView === PAYMENT_FLOW_VIEWS.CARD_FILL) return <PayWithCard />;

  return (
    <div className="position-relative pay-content">
      <div className="pt-24px pt-md-40px popup-content payment-options-cards-modal">
        <div className="font-bold font-size-20 text-dark-text text-center">{langs.PayAmount}</div>
        <div className="font-medium font-size-14 text-blue-gray text-center">{langs.ChoosePaymentMethod}</div>
        <div className="d-flex flex-column pay-check mt-32px">
          {isPaymentProcessing && <Loader />}
          {paymentOptions?.map((paymentOption) => {
            const isSelected = selectedPaymentMethod?.id === paymentOption.id;
            const isCardGroup = paymentOption.group_id === PaymentGroupEnum.Cards;
            const isSavedCard = paymentOption.id === PaymentMethodsEnum.SavedCard;
            const isExpired = moment(new Date()).isSameOrAfter(moment(selectedCard?.expire_date ?? ''));

            if (isCardGroup) {
              return (
                <PaymentCardGroup
                  key={paymentOption.id + paymentOption.name}
                  method={{ title: paymentOption.name }}
                  isSelected={[PaymentMethodsEnum.TbcCard, PaymentMethodsEnum.BogCard, PaymentMethodsEnum.OtherBankCard].includes(selectedPaymentMethod?.id)}
                  onClick={() => setSelectedPaymentMethod(paymentOption.paymentMethods.find((el) => el.id === PaymentMethodsEnum.TbcCard))}
                  saveCard={saveCard}
                  methods={paymentOption.paymentMethods}
                  // onSaveCard={(value) => setSaveCard(value)}
                  onSaveCard={() => setSaveCard(!saveCard)}
                />
              );
            }

            if (isSavedCard) {
              return (
                <PaymentSavedCard
                  key={paymentOption.id + paymentOption.name}
                  card={selectedCard}
                  isSelected={isSelected}
                  isExpired={isExpired}
                  onChange={!isExpired ? () => setSelectedPaymentMethod(paymentOption) : undefined}
                  saveCard={saveCard}
                  // onSaveCard={(value) => setSaveCard(value)}
                  onSaveCard={() => setSaveCard(!saveCard)}
                  onCardChange={() => {
                    cardSelection.toggle();
                    setSelectedPaymentMethod(paymentOption);
                    if (isExpired) setSelectedCard(false);
                  }}
                />
              );
            }

            if([PaymentMethodsEnum.Google, PaymentMethodsEnum.Apple].includes(paymentOption.id)) {
              return (
                <PaymentItem
                  key={paymentOption.id + paymentOption.name}
                  method={{ title: paymentOption.name, icon: PaymentMethodsIconsEnum[paymentOption.id], checkBalance: !isInsufficientBalanceAmount }}
                  isSelected={isSelected}
                  onChange={() => handleChangeWalletMethod(paymentOption)}
                />
              );
            }

            return (
              <PaymentItem
                key={paymentOption.id + paymentOption.name}
                method={{ title: paymentOption.name, icon: PaymentMethodsIconsEnum[paymentOption.id], checkBalance: !isInsufficientBalanceAmount }}
                isSelected={isSelected}
                isBalance={paymentOption.id === PaymentMethodsEnum.Balance}
                balance={userBalance}
                onChange={() => setSelectedPaymentMethod(paymentOption)}
              />
            );
          })}
        </div>
      </div>

      {/*<Wallets />*/}

      <div className="popup-footer d-flex justify-content-between pt-24px mt-24px">
        <div className="text-left mb-16px my-md-auto d-flex align-items-center d-md-block">
          <h2 className="font-bold-caps font-size-18 text-dark-text mr-8px m-md-0">{totalAmount} ₾</h2>
          <p className="font-base font-size-12 text-blue-gray m-0">{langs.PriceToPay}</p>
        </div>

        {[PaymentMethodsEnum.Apple, PaymentMethodsEnum.Google].includes(selectedPaymentMethod?.id) ? (
          <Wallets />
        ) : (
          <button
            disabled={!selectedPaymentMethod || isPaymentProcessing}
            className={clsx('btn bg-market-color rounded-sm font-medium font-size-14 text-dark', {
              'text-raisin-30 bg-raisin-10 pointer-events-none': !selectedPaymentMethod,
            })}
            onClick={(e) => {
              handlePayment(selectedPaymentMethod);
            }}
          >
            {langs.Pay}
          </button>
        )}
      </div>
    </div>
  );
};

export default PaymentMethods;
